import Repo from './Repo.js'

export default class VacationResponseRepository extends Repo {
  constructor () {
    super('vacation-responses')
  }

  all (q) {
    return super.all(q)
  }

  store (data) {
    return super.store(data)
  }

  update (id, data) {
    return super.update(id, data)
  }

  get (id, include) {
    return super.get(id, {include: include})
  }

  delete (id) {
    return super.delete(id)
  }

  paginate (q) {
      return super.paginate(q)
  }

  approve(data) {
      return this.http.post(this.resource + '/approve', data).then((response) => {
          return Promise.resolve(response)
      }).catch((response) => {
          return Promise.reject(response)
      })
  }

  decline(data) {
    return this.http.post(this.resource + '/decline', data).then((response) => {
        return Promise.resolve(response)
    }).catch((response) => {
        return Promise.reject(response)
    })
  }
}
